import { Link } from "react-router-dom";
import { Sparkles, X, Lock } from "lucide-react";

/**
 * Friendly upgrade modal shown when a Seeker hits a tier-gated action.
 * The backend returns a 403 with a human message; the calling component
 * can pass that message in as `reason` instead of building one.
 */
export default function UpgradeModal({ open, onClose, tier = "Believer", feature, reason }) {
  if (!open) return null;
  const friendlyReason =
    reason ||
    (feature
      ? `${feature} is part of the ${tier} tier.`
      : `This is part of the ${tier} tier.`);

  return (
    <div
      className="fixed inset-0 z-50 bg-jjblue/50 backdrop-blur-sm flex items-center justify-center px-4"
      onClick={onClose}
      data-testid="upgrade-modal-backdrop"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="jj-card max-w-md w-full p-7 sm:p-8 relative shadow-2xl"
        data-testid="upgrade-modal"
      >
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-3 right-3 text-[var(--jj-muted)] hover:text-burgundy"
          data-testid="upgrade-modal-close"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="h-12 w-12 rounded-full bg-gold/20 text-burgundy flex items-center justify-center">
          <Lock className="h-5 w-5" strokeWidth={1.7} />
        </div>

        <h2 className="font-serif text-2xl text-jjblue mt-4 leading-tight">
          A {tier} feature
        </h2>
        <p className="mt-2 text-sm text-[var(--jj-text-secondary)] leading-relaxed">
          {friendlyReason} Members who give of themselves to keep this community
          alive get to share at deeper levels — and your gift keeps the lights
          on for everyone.
        </p>

        <div className="mt-5 flex items-center gap-2 flex-wrap">
          <Link
            to="/pricing"
            onClick={onClose}
            className="btn-primary !py-2.5 !px-5 text-sm inline-flex items-center gap-2"
            data-testid="upgrade-modal-cta"
          >
            <Sparkles className="h-4 w-4" /> See {tier} plan
          </Link>
          <button
            onClick={onClose}
            className="btn-secondary !py-2 !px-4 text-sm"
            data-testid="upgrade-modal-not-now"
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
